import Layout from '@/page/layout'
// import fun
const _import = require('../_import')
// scope rent
const scope = 'amortize'

export default {
  path: '/amortize',
  name: 'amortize',
  component: Layout,
  redirect: '/amortize/index',
  meta: {title: '摊销管理', icon: ''},
  children: [{
    path: 'index',
    name: 'index',
    component: _import(`${scope}/index`),
    meta: {title: '摊销报表', icon: ''}
  }, 
  {
    path: 'expendingStatus',
    name: 'expendingStatus',
    component: _import(`${scope}/expendingStatus`),
    meta: {title: '支出摊销状态', icon: ''}
  },
  {
    path: 'situation',
    name: 'situation',
    component: _import(`${scope}/situation`),
    meta: {title: '收支情况表', icon: ''}
  },
]

}



// WEBPACK FOOTER //
// ./src/router/modules/amortize.js